import Container from '@nerdwallet/react-container';
import { Divider } from '@nerdwallet/currency/components/Divider';
import { NativeType as Type } from '@nerdwallet/currency/components/NativeType';
import {
  BUTTON,
  CONTAINER,
  DIVIDER,
  DOCUMENT,
  LINK,
  TYPE,
  WPHOUSEAD,
} from '@nerdwallet/structured-content/types';

export default {
  [BUTTON]: () => [
    import('@nerdwallet/structured-content/dist/components/button'),
  ],
  [CONTAINER]: () => Container,
  [DIVIDER]: () => Divider,
  [DOCUMENT]: () => [
    import('@nerdwallet/structured-content/dist/components/document'),
  ],
  [LINK]: () => [import('@nerdwallet/structured-content/dist/components/link')],
  [TYPE]: () => Type,
  [WPHOUSEAD]: () => [
    import('@nerdwallet/structured-content/dist/components/wp-house-ad'),
  ],
};
